import useExperiments from '@alltrails/experiments/hooks/useExperiments';

/**
 * Whether Ask AllTrails is a chat, where each question follows on from the ones before it, rather than one question at a time.
 */
const useIsAskChatEnabled = () => useExperiments()['web-disco-rm-ask-alltrails-chat']?.value === 'treatment';

export default useIsAskChatEnabled;
